import Vue from 'vue'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import layout from './components/layout'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'//轮播组件的引入
import 'swiper/css/swiper.css'
import countDown from './components/countDown'
import pagescom from './components/pagescom'
import store from './store'
import Axios from './axios'
import VueCropper from 'vue-cropper'
import VDistpicker from 'v-distpicker'


Vue.use(VueAwesomeSwiper)//轮播组件的使用
Vue.use(router)
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(VueCropper)

Vue.prototype.$store = store
Vue.component('countDown',countDown)
Vue.component('pagescom',pagescom)
Vue.component('v-distpicker', VDistpicker);


//路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

Vue.config.productionTip = false
Vue.prototype.$axios = Axios

Vue.prototype.$env = {
  // VUE_APP_URL: 'http://edu.test.dyyxclub.com/',
  // VUE_WWW_URL: 'http://www.test.dyyxclub.com/',
  VUE_APP_URL: 'https://edu.dyyxclub.com/',
  VUE_WWW_URL: 'https://www.dyyxclub.com/',
  VUE_APP_WECHAT_OFFICIAL_APPID: 'wx46c3379c3d066969', //微信扫码登录
  VUE_APP_WECHAT_OPEN_APPID: 'wx7d69f1e840455ea8', //微信浏览器登录
}

Vue.prototype.$eduRouter = {
  push: (res) => {
    window.location.href = Vue.prototype.$env.VUE_APP_URL + 'web/#/'+res;
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { layout },
  template: '<layout/>'
})



// WEBPACK FOOTER //
// ./src/main.js